import React from 'react';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import store from './store';
import { AppRoutes } from './routes';
import strings from './defaultStrings.json';
import styles from './App.module.scss';

i18next.use(initReactI18next).init({
	lng: 'en',
	fallbackLng: 'en',
	debug: false,
	resources: {
		en: { translation: strings },
	},
});

const App = () => {
	return (
		<div className={styles.app}>
			<Provider store={store}>
				<Router>
					<AppRoutes />
				</Router>
			</Provider>
		</div>
	);
};

export default App;
